import React from 'react';
import { useLocation } from 'react-router-dom';
import ProMarketingLink from './ProMarketingLink';
import { useAuth } from '../../context/AuthContext';
import {
  ACACED_APP_PATH,
  ACACED_HERO_BADGE,
  ACACED_PAGE_PATH,
  ACACED_TEASER_CTA_LABEL,
  ACACED_TEASER_METIER_PATHS,
  ACACED_TEASER_TEXT,
  ACACED_TEASER_TITLE,
} from '../../config/acacedOffer';
import { captureBackofficeEvent } from '../../analytics';
import './AcacedTeaser.css';

/** Pages FR où l'encart s'affiche (landing + métiers concernés). Offre réservée à la France. */
const TEASER_PATHS: readonly string[] = ['/', ...ACACED_TEASER_METIER_PATHS];

export function isAcacedTeaserPath(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return TEASER_PATHS.includes(normalized);
}

interface AcacedTeaserProps {
  /** Emplacement pour l'analytics (landing, metier…). */
  placement: string;
}

export default function AcacedTeaser({ placement }: AcacedTeaserProps) {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  if (!isAcacedTeaserPath(pathname)) return null;

  const href = isAuthenticated ? ACACED_APP_PATH : ACACED_PAGE_PATH;

  return (
    <section className="acaced-teaser" aria-label={ACACED_HERO_BADGE}>
      <div className="acaced-teaser__inner">
        <span className="acaced-teaser__badge">{ACACED_HERO_BADGE}</span>
        <div className="acaced-teaser__copy">
          <h2 className="acaced-teaser__title">{ACACED_TEASER_TITLE}</h2>
          <p className="acaced-teaser__text">{ACACED_TEASER_TEXT}</p>
        </div>
        <ProMarketingLink
          to={href}
          className="acaced-teaser__cta"
          onClick={() => captureBackofficeEvent('acaced_teaser_clicked', { placement })}
        >
          {ACACED_TEASER_CTA_LABEL} →
        </ProMarketingLink>
      </div>
    </section>
  );
}
